/* eslint-disable */

import React, { useState } from "react";
import { Modal, Button, Input, Form, ConfigProvider } from "antd";
import { Alert, Spin, message } from "antd";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import axios from "axios";

const AnalysisModal = ({ product }) => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [analysisResult, setAnalysisResult] = useState(null);
  const [formData, setFormData] = useState({
    profitMargin: "",
  });
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const CostPerAction = () => {
    const purchaseResult = product?.campaignInfo24?.costPerAction?.find(
      (costPerAction) => costPerAction.action_type === "purchase"
    );
    return purchaseResult?.value
      ? parseFloat(purchaseResult.value).toFixed(2)
      : "0.00";
  };

  const handleAnalyze = async () => {
    if (!product || !product.name || !product.campaignInfo24) {
      setAnalysisResult(t("insightads.Table.Analysis.invalid_data"));
      return;
    }

    setLoading(true);
    setAnalysisResult(null);

    try {
      const estimatedClicks =
        product.campaignInfo24.impressions * (product.campaignInfo24.ctr / 100);
      const cpcEstimate =
        estimatedClicks > 0
          ? (product.campaignInfo24.amountSpent / estimatedClicks).toFixed(2)
          : "غير متوفر";

      const response = await fetch("https://backend.foorweb.store/api/chatgpt/analyze", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          product: {
            name: product.name,
            campaignInfo24: product.campaignInfo24,
            profitMargin: product.profitMargin,
            conversionRate: CostPerAction(),
            cpcEstimate,
          },
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData?.error || "Server error");
      }

      const data = await response.json();
      setAnalysisResult(data.analysis);
    } catch (error) {
      console.error("Error fetching analysis:", error);
      setAnalysisResult(t("insightads.Table.Analysis.error_fetch"));
    } finally {
      setLoading(false);
    }
  };

  const FormattedResponse = ({ analysisResult }) => {
    return (
      <div
        className={`mt-4 p-4 border rounded bg-gray-100 ${
          isRTL ? "text-right" : "text-left"
        }`}
        dir={i18n.dir()}
      >
        {analysisResult.split("\n").map((line, index) => (
          <p key={index}>
            {line.startsWith("🔍") ||
            line.startsWith("📈") ||
            line.startsWith("💬") ||
            line.startsWith("💲") ||
            line.startsWith("💰") ||
            line.startsWith("🔄") ||
            line.startsWith("🛒") ||
            line.startsWith("📊") ||
            line.startsWith("💵") ||
            line.startsWith("ملخص:") ? (
              <span className="font-bold text-gray-900">{line}</span>
            ) : (
              line
            )}
          </p>
        ))}
      </div>
    );
  };
  const showLoading = () => {
    setOpen(true);
    setLoading(true);

    // Simple loading mock. You should add cleanup logic in real world.
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };
  const [messageApi, contextHolder] = message.useMessage(); // استخدام messageApi و contextHolder

  const success = () => {
    messageApi.open({
      type: "error",
      content: t("insightads.Table.Analysis.no_campaign"),
      style: {
        marginTop: "10vh",
        // marginBottom: "20vh",
        direction: i18n.dir(),
      },
    });
    setTimeout(messageApi.destroy, 2500);
  };
  return (
    <>
      <ConfigProvider direction={i18n.dir()}>
        <>
          {contextHolder}

          <button
            onClick={() => {
              if (!product?.campaignId) {
                success();
                return;
              }
              setVisible(true);
            }}
            className="ant-btn css-var-rmm ant-btn-dashed ant-btn-color-default ant-btn-variant-dashed relative z-10 dark:bg-[#181819] dark:text-white dark:border-[#3c3a3d] "
            style={{
              padding: "10px",
              background: "white",
              borderRadius: "8px",
            }}
          >
            <img
              src="/metaAi.gif" // رابط الـ GIF
              style={{ width: "40px" }} // حجم صغير داخل الزر
              alt={t("ui.buttonIcon")}
            />
          </button>

          <Modal
            title={
              analysisResult
                ? null
                : `${t("insightads.Table.Analysis.title")} - ${product.name}`
            }
            open={visible}
            onCancel={() => setVisible(false)}
            footer={null}
            loading={loading}
            centered={analysisResult ? null : true}
            width={analysisResult ? 1000 : 500}
          >
            <div>
              {!analysisResult && (
                <>
                  <div className="flex justify-center items-center">
                    <img
                      src="/MetaAis.png" // ضع رابط شعار الصورة هنا
                      alt="foorweb"
                      className="w-[400px] h-[400px] object-contain"
                    />
                  </div>
                </>
              )}
              <div className="space-y-4 text-center">
                {loading ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "16px",
                    }}
                  >
                    <Spin tip="Loading...">
                      <Alert
                        message={t("insightads.Table.Analysis.loading_message")}
                        description={t(
                          "insightads.Table.Analysis.loading_description"
                        )}
                        type="info"
                      />
                    </Spin>
                  </div>
                ) : (
                  analysisResult && (
                    <>
                      <h2 className="text-lg font-semibold">
                        {t("insightads.Table.Analysis.ai_title")}
                      </h2>
                      <p className="text-gray-500">
                        {t("insightads.Table.Analysis.description")}
                      </p>
                      <div className="border-b my-4"></div>
                      <div className="bg-gray-100 p-6 rounded-md shadow-md text-right">
                        <FormattedResponse analysisResult={analysisResult} />
                      </div>
                    </>
                  )
                )}

                {/* زر الإغلاق */}
                {!loading && analysisResult && (
                  <button
                    onClick={() => setVisible(false)}
                    className="mt-6 px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 mr-4"
                    style={{
                      width: "310px", // عرض الزر 400 بكسل
                      height: "50px", // ارتفاع الزر ليبدو متناسقًا
                    }}
                  >
                    {t("insightads.Table.Analysis.close")}
                  </button>
                )}

                {/* زر التحليل */}
                {!analysisResult && (
                  <button
                    onClick={handleAnalyze}
                    className="ant-btn css-var-rmm ant-btn-dashed ant-btn-color-default ant-btn-variant-dashed"
                    style={{
                      width: "312px", // عرض الزر 400 بكسل
                      height: "50px", // ارتفاع الزر ليبدو متناسقًا
                      display: "block", // تضمن ظهور الزر في وسط الصفحة
                      margin: "0 auto", // تضمن تمركز الزر أفقيًا
                    }}
                  >
                    {t("insightads.Table.Analysis.analyze")}
                  </button>
                )}
              </div>
            </div>
          </Modal>
        </>
      </ConfigProvider>
    </>
  );
};

export default AnalysisModal;
